"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * A type of pivot that uses a drop list for navigation instead of tabs.
         */
        var DropList = /** @class */ (function (_super) {
            __extends(DropList, _super);
            function DropList() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            DropList.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.ActiveItemLabel = $dyn.computed(function () {
                    var activeItem = _this.ActiveItem();
                    return activeItem ? $dyn.value(activeItem.Label) : undefined;
                });
            };
            /**
             * @returns The active (currently visible) item in the pivot.
             */
            DropList.prototype.ActiveItem = function () {
                var e_1, _a;
                var activeItem;
                var activeName = this.activeItemName();
                var children = $dyn.value(this.Children);
                try {
                    for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                        var item = children_1_1.value;
                        if (item.Name === activeName) {
                            activeItem = item;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return activeItem;
            };
            return DropList;
        }(controls.PivotBase));
        controls.DropList = DropList;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DropList.js.map
